const nameSpace = 'currentAgency'

export const mutations = {
  INITIALIZE: `${nameSpace}/INITIALIZE`,
}

export const actions = {
  INITIALIZE: `${nameSpace}/INITIALIZE`,
}

export const getters = {
  currentAgencyId: `${nameSpace}/currentAgencyId`,
}
